import * as React from "react";
import { CommonHelper, Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { SelectEditorFactory } from "../../../../../../../../react-core/Html/Factories/SelectEditorFactory";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ObjectComparer } from "../../../../../../../../react-core/Utils/ObjectComparer";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { AccountModelView } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/AccountModelView";
import { InvestmentTransactionCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/InvestmentTransactionCollection";
import { InvestmentTransactions } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/InvestmentTransactions";
import { TransactionInvestmentsColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionInvestmentsColumns";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ExcelExportAction } from "../../../../../../../Shared/ExcelExport/Actions/ExcelExportAction";
import { ExcelExportButton } from "../../../../../../../Shared/ExcelExport/ExcelExportButton";
import { sortDirection, Table, ITableConfig } from "../../../../../../../Shared/Table/Table";
import { TableColEditor } from "../../../../../../../Shared/TableColFilter/TableColEditor";
import { AccountModelPortfolioAction } from "../Actions/AccountModelPortfolioActions";
import { AdvancedSearch } from "../Components/AdvancedSearch";
import { TransactionHistoryPopupView } from "../Components/TransactionHistoryPopupView";
import {
    SortNameEnum,
    UnModelTypeOptions,
    ModelTypeOptions,
    TransactionEnum,
    Contents,
    InvestmentTransactionTypeMap,
} from "../Resource/Contents";
import { AccountModelPortfolioStore } from "../Store/Variable";
import { TransactionDetailPopupView } from "./TransactionDetailPopupView";

interface IInvestmentsProps {
    isLoading: boolean;
    hierarchyId: string;
    data: InvestmentTransactionCollection;
    instrucmentCode?: string;
    fromDate?: Date;
    toDate?: Date;
    onTableChange: (
        transSource,
        modelId,
        sortName,
        sortDirection,
        minRow,
        maxRow,
        newHierarchyId?,
        cNoteId?,
        instrumentCode?
    ) => void;
}

interface IInvestmentsState {
    transSource: string;
    modelFundInstrumentId: number;
    modelId: number;
    sortName: SortNameEnum;
    sortDirection: sortDirection;
    currentPage: number;
    isPopUp: boolean;
    isHistoryPopUp: boolean;
    selectedRow: InvestmentTransactions;
    isExDateASC: boolean;
    isUnitCostASC: boolean;
    newHierarchyId: string;
    cNoteId: number;
    instrumentCode: string;
    accountModelView: AccountModelView;
}

export class Investments extends FormComponent<IInvestmentsProps, IInvestmentsState> {
    constructor(props: IInvestmentsProps) {
        super(props);

        this.state = {
            transSource: UnModelTypeOptions[0].key, //Set default transactionType to "All"
            modelFundInstrumentId: 0,
            modelId: 0,
            sortName: SortNameEnum.AsAt,
            sortDirection: sortDirection.DESC,
            currentPage: 1,
            isPopUp: false,
            isHistoryPopUp: false,
            selectedRow: null,
            isExDateASC: false,
            isUnitCostASC: false,
            newHierarchyId: null,
            cNoteId: 0,
            instrumentCode: this.props.instrucmentCode,
            accountModelView: null,
        };

        this.subscribeToStore(AccountModelPortfolioStore, () => this.onAccoutModelViewStoreChange());
    }

    componentDidMount() {
        this.onAccoutModelViewStoreChange();
    }

    private onAccoutModelViewStoreChange() {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (!data && !CommonHelper.isNullOrEmpty(this.props.hierarchyId)) {
            AccountModelPortfolioAction.getAccountModelPortfolio(this.props.hierarchyId, false);
        } else if (data) {
            const data = AccountModelPortfolioStore.getAccountModelData();
            const isSame = ObjectComparer.isSame(data, this.state.accountModelView);

            if (!isSame) {
                AccountModelPortfolioAction.getAccountModelPortfolio(this.props.hierarchyId, false);
                this.setState({
                    accountModelView: AccountModelPortfolioStore.getAccountModelData(),
                });
            }
        }
    }

    private getData() {
        const {
            transSource,
            sortName,
            sortDirection,
            currentPage,
            modelId,
            newHierarchyId,
            cNoteId,
            instrumentCode,
        } = this.state;
        const minRow = (currentPage - 1) * 10 + 1;
        const maxRow = currentPage * 10;
        this.props.onTableChange(
            transSource,
            modelId,
            sortName,
            sortDirection,
            minRow,
            maxRow,
            newHierarchyId,
            cNoteId,
            instrumentCode
        );
    }

    private getTransactionTypeOptions(): Dictionary[] {
        const { modelFundInstrumentId } = this.state;
        let _options: Dictionary[] = [];
        if (modelFundInstrumentId == 0) {
            _options = UnModelTypeOptions;
        } else {
            _options = ModelTypeOptions;
        }
        return _options;
    }

    private getModelPortfolioOptions(hierarchyId: string): Dictionary[] {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            const ckIsSelectPortfolio = this.ckIsSelectPortfolio(hierarchyId);
            if (ckIsSelectPortfolio) {
                return this.getAllSubAccountOptions();
            } else {
                return this.getSubAccountOptionsFromHierarchyId(hierarchyId);
            }
        } else {
            const _subAccoutOptions: Dictionary[] = [];
            return _subAccoutOptions;
        }
    }
    private ckIsSelectPortfolio(hierarchyId: string): boolean {
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            if (hierarchyId.length != data.HeadAccount.HierarchyId.length) {
                let str = "";
                const diff =
                    data.HeadAccount.HierarchyId.split("-")[1].toString().length -
                    hierarchyId.split("-")[1].toString().length;
                for (let i = 0; i < diff; i++) {
                    str += "0";
                }
                str = "-" + str;
                const _hierarchyId = hierarchyId.split("-")[0] + str + hierarchyId.split("-")[1];
                return _hierarchyId == data.HeadAccount.HierarchyId;
            } else {
                return hierarchyId == data.HeadAccount.HierarchyId;
            }
        } else {
            return false;
        }
    }
    private getAllSubAccountOptions(): Dictionary[] {
        const _subAccoutOptions: Dictionary[] = [];
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            data.SubAccounts.map((item) => {
                const name =
                    item.ModelDisplayName + " " + item.SubClaccountId.substr(item.SubClaccountId.indexOf("-") + 1);
                _subAccoutOptions.push({ key: item.ModelFundInstrumentId + "", value: name });
            });
        }
        return _subAccoutOptions;
    }
    private getSubAccountOptionsFromHierarchyId(hierarchyId: string): Dictionary[] {
        const _subAccoutOptions: Dictionary[] = [];
        const data = AccountModelPortfolioStore.getAccountModelData();
        if (data) {
            const findSubAccounts = data.HeadAccount.SubAccounts.filter((x) => x.HierarchyId == hierarchyId);
            if (findSubAccounts.length > 0) {
                const clAccountId = findSubAccounts[0].ClAccountId;
                data.SubAccounts.map((item) => {
                    if (item.SubClaccountId == clAccountId) {
                        const name =
                            item.ModelDisplayName + " " + item.SubClaccountId.substr(item.SubClaccountId.indexOf("-"));
                        _subAccoutOptions.push({ key: item.ModelFundInstrumentId + "", value: name });
                    }
                });
            }
        }
        return _subAccoutOptions;
    }

    private onModelPortfolioSelectChange(modelFundInstrumentId: string) {
        const { hierarchyId, onTableChange } = this.props;
        const { transSource } = this.state;
        const data = AccountModelPortfolioStore.getAccountModelData();

        if (data) {
            if (modelFundInstrumentId) {
                const findsubAccounts = data.SubAccounts.filter(
                    (x) => x.ModelFundInstrumentId + "" == modelFundInstrumentId
                );
                if (findsubAccounts.length > 0) {
                    const subAccount = findsubAccounts[0];
                    const modelFundInstrumentId = subAccount.ModelFundInstrumentId;
                    const inceptionDate = (subAccount.InceptionDate + "").split("T")[0];
                    let hierarchyId = null;
                    const ckIsSelectPortfolio = this.ckIsSelectPortfolio(this.props.hierarchyId);
                    if (!ckIsSelectPortfolio) {
                        const account = data.HeadAccount.SubAccounts.filter(
                            (x) => x.ClAccountId == subAccount.SubClaccountId
                        )[0];
                        hierarchyId = account ? account.HierarchyId : null;
                    } else {
                        hierarchyId = data.HeadAccount.HierarchyId;
                    }
                    const { newHierarchyId, modelId } = this.getHierarchyIdAndModelId(
                        hierarchyId,
                        modelFundInstrumentId
                    );
                    this.setState({ newHierarchyId: newHierarchyId, modelId: modelId }, () => {
                        onTableChange(
                            transSource,
                            modelId,
                            SortNameEnum.AsAt,
                            sortDirection.DESC,
                            1,
                            10,
                            newHierarchyId
                        );
                    });
                }
            } else {
                // if select all
                const { newHierarchyId, modelId } = this.getHierarchyIdAndModelId(hierarchyId, modelFundInstrumentId);
                this.setState({ newHierarchyId: newHierarchyId, modelId: modelId }, () => {
                    onTableChange(transSource, modelId, SortNameEnum.AsAt, sortDirection.DESC, 1, 10, newHierarchyId);
                });
            }
        }
    }

    private getHierarchyIdAndModelId(hierarchyId, modelFundInstrumentId) {
        const data = AccountModelPortfolioStore.getAccountModelData();
        let _hierarchyId = "";
        let _modelId = 0;

        if (modelFundInstrumentId) {
            const isPortfolio = hierarchyId == data.HeadAccount.HierarchyId;
            if (isPortfolio) {
                const finds = data.SubAccounts.filter((x) => x.ModelFundInstrumentId == modelFundInstrumentId);
                if (finds && finds.length > 0) {
                    const subClaccountId = finds[0].SubClaccountId;
                    const findObj = data.HeadAccount.SubAccounts.filter((x) => x.ClAccountId == subClaccountId);
                    if (findObj && findObj.length > 0) {
                        _hierarchyId = findObj[0].HierarchyId;
                    }
                    _modelId = finds[0].ModelId;
                }
            } else {
                const findDatas = data.SubAccounts.filter((x) => x.ModelFundInstrumentId == modelFundInstrumentId);
                _modelId = findDatas.length > 0 ? findDatas[0].ModelId : _modelId;
                _hierarchyId = hierarchyId;
            }
        } else {
            _hierarchyId = hierarchyId;
        }
        return { newHierarchyId: _hierarchyId, modelId: _modelId };
    }

    private renderModelPortfolioSelect(): JSX.Element {
        const { modelFundInstrumentId } = this.state;
        const ModelPortfolioSelect = SelectEditorFactory.create<string>();
        const { hierarchyId } = this.props;
        const _modelPortfolioOptions = this.getModelPortfolioOptions(hierarchyId);
        if (_modelPortfolioOptions) {
            return (
                <div className="col-12 col-sm-fluid col-max-245">
                    <ModelPortfolioSelect
                        label="MPS model"
                        options={_modelPortfolioOptions.map((item) => item.key)}
                        getText={(key) => CommonHelper.getOptionsTxt(key, _modelPortfolioOptions)}
                        selected={modelFundInstrumentId + ""}
                        placeholder="Please select"
                        onChange={(val) => {
                            this.setState({ modelFundInstrumentId: Number(val) }, () => {
                                this.onModelPortfolioSelectChange(val);
                            });
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    private renderElement(): JSX.Element {
        const { modelId, transSource, newHierarchyId } = this.state;
        const TransactionTypeSelect = SelectEditorFactory.create<string>();
        const _TransTypeOptions = this.getTransactionTypeOptions();
        return (
            <div>
                <hr className="divider mt-15 mb-30" />
                <div className="row">
                    <div className="col-12 col-sm-fluid col-max-245">
                        <TransactionTypeSelect
                            key="TransactionType"
                            label="Transaction type"
                            selected={_TransTypeOptions.filter((x) => x.key == transSource)[0].key + ""}
                            options={_TransTypeOptions.map((item) => item.key + "")}
                            getText={(x) => CommonHelper.getOptionsTxt(x, _TransTypeOptions)}
                            onChange={(val) => {
                                const value = _TransTypeOptions.filter((x) => x.key == val)[0].key;
                                this.setState({ transSource: value }, () => {
                                    this.props.onTableChange(
                                        value,
                                        modelId,
                                        SortNameEnum.AsAt,
                                        sortDirection.DESC,
                                        1,
                                        10,
                                        newHierarchyId
                                    );
                                });
                            }}
                        />
                    </div>
                    {this.renderModelPortfolioSelect()}
                </div>
                {this.renderAdvanceSearch()}
                {this.renderTableContent()}
                {this.renderDetailPopUp()}
                {this.renderHistoryPopUp()}
            </div>
        );
    }

    private renderAdvanceSearch() {
        const { data } = this.props;
        const { modelFundInstrumentId, instrumentCode } = this.state;
        if (!(data && data.InvestmentTransactions.length < 1) && modelFundInstrumentId < 1) {
            return (
                <AdvancedSearch
                    transactionType={TransactionEnum.investments}
                    instrumentCode={instrumentCode}
                    onChange={(instrumentCode, cNoteId) => {
                        this.setState({ cNoteId: cNoteId, instrumentCode: instrumentCode }, () => {
                            this.getData();
                        });
                    }}
                />
            );
        }
    }

    private renderTableContent() {
        const { currentPage } = this.state;
        const { data, isLoading } = this.props;
        if (isLoading || !data) {
            return <PartLoading isLoading={true} />;
        } else if (data && data.InvestmentTransactions.length < 1) {
            return <Alert alertType={AlertType.Warning} message={Contents.NoInvestmentDataErrorMessage} />;
        } else {
            return (
                <div className="mb-50">
                    {this.renderTableFilter()}
                    <Table
                        data={data.InvestmentTransactions}
                        col={this.getTransactionTableColumn()}
                        colEditorKey="TransactionInvestmentsColumnSettings"
                        needPagination={{
                            totalNumOfResult: data.TotalRows,
                            currentPage: currentPage,
                            onPaginationChange: (pageIndex, pageSize) => {
                                this.setState(
                                    {
                                        currentPage: pageIndex,
                                    },
                                    () => {
                                        this.getData();
                                    }
                                );
                            },
                        }}
                    />
                </div>
            );
        }
    }

    private getTransactionTableColumn() {
        const { isExDateASC, isUnitCostASC, modelFundInstrumentId } = this.state;

        const tableColConfig: ITableConfig[] = [
            {
                title: "Date",
                key: "Date",
                thCssWrapper: "ctable-sort",
                tableFilter: TransactionInvestmentsColumns.Date,
                render: (data, row, index) => {
                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                },
                filterOption: { disableEdit: true },
                sorter: () => {
                    this.setState(
                        {
                            sortName: SortNameEnum.AsAt,
                            sortDirection: isExDateASC ? sortDirection.DESC : sortDirection.ASC,
                            isExDateASC: !isExDateASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isExDateASC ? sortDirection.ASC : sortDirection.DESC,
            },
            {
                title: "Investments",
                key: "Investments",
                tableFilter: TransactionInvestmentsColumns.Investments,
                filterOption: { disableEdit: true },
            },
            {
                title: "Instrument code",
                key: "InstrumentCode",
                tableFilter: TransactionInvestmentsColumns.InstrumentCode,
            },
            {
                title: "Product",
                key: "ProductDisplayName",
                tableFilter: TransactionInvestmentsColumns.ProductDisplayName,
                filterOption: { disableEdit: true },
                render: (data, row: InvestmentTransactions, index) => {
                    return row.ProductDisplayName ? row.ProductDisplayName : row.ProductType;
                },
            },
            {
                title: "Quantity",
                key: "Quantity",
                tableFilter: TransactionInvestmentsColumns.Quantity,
                filterOption: { disableEdit: true },
                render: (data, row, index) => {
                    return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, false, 4);
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },
            {
                title: "Unit cost",
                key: "Cost",
                thCssWrapper: "ctable-sort cell-right",
                tdCssWrapper: "cell-right",
                tableFilter: TransactionInvestmentsColumns.UnitCost,
                filterOption: { disableEdit: true },
                render: (data, row: InvestmentTransactions, index) => {
                    if (!isNaN(Number(row.InstrumentCode)) && data == 0) {
                        return null;
                    }
                    return MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 4);
                },
                sorter: () => {
                    this.setState(
                        {
                            sortName: SortNameEnum.UnitCost,
                            sortDirection: isUnitCostASC ? sortDirection.DESC : sortDirection.ASC,
                            isUnitCostASC: !isUnitCostASC,
                        },
                        () => {
                            this.getData();
                        }
                    );
                },
                sortDirection: isUnitCostASC ? sortDirection.ASC : sortDirection.DESC,
            },
            {
                title: "Total cost",
                key: "Cost",
                tableFilter: TransactionInvestmentsColumns.TotalCost,
                filterOption: { disableEdit: true },
                render: (data, row: InvestmentTransactions, index) => {
                    if (!isNaN(Number(row.InstrumentCode))) {
                        return null;
                    }
                    return MoneyDisplayHelper.FromatMoneyDisplay(row.Cost * row.Quantity, CurrencyCode.GBP, true, 2);
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },
            {
                title: "Type",
                key: "TransType",
                tableFilter: TransactionInvestmentsColumns.TransType,
                filterOption: { disableEdit: true },
                render: (data, row: InvestmentTransactions, index) => {
                    return InvestmentTransactionTypeMap[row.TransSource];
                },
            },
            {
                title: "Location",
                key: "Location",
                tableFilter: TransactionInvestmentsColumns.Location,
            },
            {
                title: "Status",
                key: "TransStatus",
                tableFilter: TransactionInvestmentsColumns.TransStatus,
                filterOption: { disableEdit: true },
            },
            modelFundInstrumentId < 1
                ? {
                      title: "Detail",
                      key: "TransID",
                      thCssWrapper: "cell-center",
                      tdCssWrapper: "cell-center",
                      userClaim: UserClaim.AdviserPortalInvestmentTransactionColumnDetailCanView,
                      tableFilter: TransactionInvestmentsColumns.Detail,
                      filterOption: { disableEdit: true },
                      render: (data, row, index) => {
                          return (
                              <button className="forward-button label-sr-only">
                                  <span className="icon" aria-hidden="true"></span>
                                  <span className="text">View transaction detail</span>
                              </button>
                          );
                      },
                      onClick: (data, row: InvestmentTransactions, index) => {
                          this.setState({ selectedRow: row, isPopUp: true });
                      },
                  }
                : null,
            modelFundInstrumentId < 1
                ? {
                      title: "History",
                      key: "TransID",
                      thCssWrapper: "cell-center",
                      tdCssWrapper: "cell-center",
                      userClaim: UserClaim.AdviserPortalInvestmentTransactionColumnHistoryCanView,
                      tableFilter: TransactionInvestmentsColumns.History,
                      filterOption: { disableEdit: true },
                      render: (data, row, index) => {
                          return (
                              <button className="forward-button label-sr-only">
                                  <span className="icon" aria-hidden="true"></span>
                                  <span className="text">View transaction history</span>
                              </button>
                          );
                      },
                      onClick: (data, row: InvestmentTransactions, index) => {
                          this.setState({ selectedRow: row, isHistoryPopUp: true });
                      },
                  }
                : null,
        ]; // all table column config

        return tableColConfig;
    }

    private renderTableFilter() {
        const {
            transSource,
            sortName,
            sortDirection,
            currentPage,
            modelId,
            newHierarchyId,
            cNoteId,
            instrumentCode,
        } = this.state;
        const { fromDate, toDate, hierarchyId } = this.props;
        return (
            <div className="row row-right wide-gutter mb-10">
                <div className="col-auto col-middle">
                    <TableColEditor
                        col={this.getTransactionTableColumn()}
                        tableEditorKey="TransactionInvestmentsColumnSettings"
                        title="Table editor"
                    />
                </div>
                <div className="col-auto col-middle">
                    <ExcelExportButton
                        onRequestReport={() => {
                            const noteId = cNoteId ? cNoteId : 0;
                            return ExcelExportAction.generateInvestmentTransactionReport(
                                newHierarchyId ? newHierarchyId : hierarchyId,
                                fromDate,
                                toDate,
                                noteId,
                                instrumentCode,
                                transSource,
                                sortName,
                                sortDirection,
                                modelId
                            );
                        }}
                        selectedAccount={newHierarchyId ? newHierarchyId : hierarchyId}
                    ></ExcelExportButton>
                </div>
            </div>
        );
    }

    private renderDetailPopUp(): JSX.Element {
        const { isPopUp, selectedRow } = this.state;
        if (isPopUp) {
            return (
                <TransactionDetailPopupView
                    showBox={isPopUp}
                    transId={selectedRow.TransID}
                    onChange={() => {
                        this.setState({ isPopUp: false });
                    }}
                    disinvestmentCharges={selectedRow.DisinvestmentCharges}
                    productType={selectedRow.ProductType}
                />
            );
        }
        return null;
    }

    private renderHistoryPopUp(): JSX.Element {
        const { isHistoryPopUp, selectedRow } = this.state;
        if (isHistoryPopUp) {
            return (
                <TransactionHistoryPopupView
                    showBox={isHistoryPopUp}
                    transId={selectedRow.TransID}
                    orderId={selectedRow.AWOrderID}
                    onChange={() => {
                        this.setState({ isHistoryPopUp: false });
                    }}
                />
            );
        }
        return null;
    }

    render() {
        return this.renderElement();
    }
}
